/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PauseSubscription
 */
export interface PauseSubscription {
    /**
     * 
     * @type {Date}
     * @memberof PauseSubscription
     */
    resume_on: Date;
}

/**
 * Check if a given object implements the PauseSubscription interface.
 */
export function instanceOfPauseSubscription(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resume_on" in value;

    return isInstance;
}

export function PauseSubscriptionFromJSON(json: any): PauseSubscription {
    return PauseSubscriptionFromJSONTyped(json, false);
}

export function PauseSubscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PauseSubscription {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resume_on': (new Date(json['resume_on'])),
    };
}

export function PauseSubscriptionToJSON(value?: PauseSubscription | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'resume_on': (value.resume_on.toISOString()),
    };
}

